import { RedeemStatusEnum } from '@wix/ambassador-premium-my-domains/types';
export const ONE_SECOND_IN_MILLISECONDS = 1000;
export const ONE_MINUTE_IN_MILLISECONDS = 60 * ONE_SECOND_IN_MILLISECONDS;
export const ONE_HOUR_IN_MILLISECONDS = 60 * ONE_MINUTE_IN_MILLISECONDS;
export const ONE_DAY_IN_MILLISECONDS = 24 * ONE_HOUR_IN_MILLISECONDS;
export var SitePermissions;
(function (SitePermissions) {
    SitePermissions["HTML_EDITOR_PUBLISH"] = "html-editor.publish";
})(SitePermissions || (SitePermissions = {}));
export var BillingCycle;
(function (BillingCycle) {
    BillingCycle["MONTHLY"] = "MONTHLY";
    BillingCycle["YEARLY"] = "YEARLY";
    BillingCycle["YEAR2"] = "YEAR2";
    BillingCycle["YEAR3"] = "YEAR3";
    BillingCycle["YEAR4"] = "YEAR4";
    BillingCycle["YEAR5"] = "YEAR5";
    BillingCycle["YEAR10"] = "YEAR10";
})(BillingCycle || (BillingCycle = {}));
export var ReferralsForExternalApps;
(function (ReferralsForExternalApps) {
    ReferralsForExternalApps["STATUS_PAGE"] = "get-domain__status-page";
})(ReferralsForExternalApps || (ReferralsForExternalApps = {}));
export var ExperimentSpecs;
(function (ExperimentSpecs) {
    ExperimentSpecs["DomainsBigAccountMode"] = "specs.premium.DomainsBigAccountMode_DOM_405";
    ExperimentSpecs["EnablePremiumDomainsType2"] = "specs.premium.EnablePremiumType2DomainsSpec";
    ExperimentSpecs["RedirectToLeanPackagePicker"] = "specs.premium.domains.RedirectToLeanPackagePicker_DOM2_4472";
    ExperimentSpecs["PostPremiumDomainUpsell"] = "specs.premium.PostPremiumDomainUpsell";
    ExperimentSpecs["FEDPicasso"] = "specs.premium.DomainsFEDPicasso";
    ExperimentSpecs["DomainsTLDsPromotionsChange"] = "specs.premium.DomainsTLDsPromotionsChange_DOM2-5314";
    ExperimentSpecs["FullProtectionUI"] = "specs.premium.domains.FullProtectionUI";
    /** Not really 2 different specs, in order to return boolean value need to split key */
    ExperimentSpecs["AddInsuranceProtectionB"] = "specs.premium.domains.AddInsuranceProtectionDOM2-5348_B";
    ExperimentSpecs["AddInsuranceProtectionC"] = "specs.premium.domains.AddInsuranceProtectionDOM2-5348_C";
    ExperimentSpecs["JapaneseContentConcierge"] = "specs.premium.domains.JapaneseContentConcierge";
    ExperimentSpecs["JapaneseContentMyDomains"] = "specs.premium.domains.JapaneseContentMyDomains";
    ExperimentSpecs["PremiumSaleContentChange"] = "specs.premium.permenant50off";
    ExperimentSpecs["PremiumUpsellBanner"] = "specs.premium.domains.PremiumUpsellBanner";
    ExperimentSpecs["ConnectDomainMobile"] = "specs.premium.connectDomainMobile";
    ExperimentSpecs["SplitOptimisations"] = "specs.premium.domains.split.optimisations";
    ExperimentSpecs["AvailableTldsModal"] = "specs.premium.domains.AvailableTldsModal";
    ExperimentSpecs["DomainsAssignmentFedMigration"] = "specs.premium.domains.domainsAssignmentFedMigration";
    ExperimentSpecs["MatchDomainCycleToPremiumCycle"] = "matchDomainCycleToPremiumCycle";
    ExperimentSpecs["SplitPageStorefrontOptimizationsPlanPrice"] = "splitPageStorefrontOptimizationsPlanPrice";
    ExperimentSpecs["DynamicSalePercentage"] = "domainsDynamicSalePercentage";
    ExperimentSpecs["BmHarmonyTheme"] = "bmHarmonyTheme";
})(ExperimentSpecs || (ExperimentSpecs = {}));
// assist https://bo.wix.com/wow/permissions/ if needed //
export var DomainsPermissions;
(function (DomainsPermissions) {
    DomainsPermissions["AccountLevelPurchaseDomain"] = "premium.purchaseDomain";
    DomainsPermissions["AccountLevelManageDomains"] = "premium.manageDomains";
    DomainsPermissions["SiteLevelManageDomains"] = "my-account.connect-domain";
    DomainsPermissions["SiteLevelPurchaseDomain"] = "premium.DomainsPurchasePageController.domainPurchasePage.siteLevel";
})(DomainsPermissions || (DomainsPermissions = {}));
export const RedeemStatus = {
    ...RedeemStatusEnum,
    INTERNAL_TECHNICAL_ERROR: 'INTERNAL_TECHNICAL_ERROR',
    NO_PERMISSIONS_ERROR: 'NO_PERMISSIONS_ERROR',
};
//# sourceMappingURL=constants.js.map